<template>
  <div class="mouse-custom"
    v-if="!touchDevice"
    :class="{
      'mouse-custom--hover': isHover,
      'mouse-custom--hover--big': isHoverBig
    }"
    v-mouse-pointer
    v-mouse-hover>
      <div></div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'MousePointer',
  data: () => ({
    touchDevice: true,
    isHover: false,
    isHoverBig: false
  }),
  mounted () {
    window.addEventListener('touchstart', () => { this.touchDevice = true })
    window.addEventListener('mousemove', () => { this.touchDevice = false })
  },
  directives: {
    'mouse-hover': {
      bind (el, binding, vnode) {
        document.addEventListener('mouseover', (e) => {
          if (!e.target.closest('a') && !e.target.closest('button') && !e.target.closest('.Cookie__button')) {
            vnode.context.isHover = false
            vnode.context.isHoverBig = false
            document.body.classList.remove('no-pointer')
          } else {
            vnode.context.isHover = true
            if (e.target.closest('.home a')) {
              vnode.context.isHoverBig = true
            }
            document.body.classList.add('no-pointer')
          }
        })
      }
    },
    'mouse-pointer': {
      bind (el, binding, vnode) {
        const render = () => {
          anime.set(el, {
            translateX: el.clientX,
            translateY: el.clientY
          })
          requestAnimationFrame(render)
        }
        requestAnimationFrame(render)
        document.addEventListener('mousemove', (e) => {
          anime.set(el, {
            translateX: e.clientX - el.getBoundingClientRect().width / 2,
            translateY: e.clientY - el.getBoundingClientRect().height / 2
          })
        })
      }
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
